<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeThankyouGame"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeThankyouGame" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <div class="w-100 d-flex justify-center" style="z-index: 1">
      <div class="table-show" style="width: 100%">
        <div class="w-100 px-4 pt-4">
          <div
            v-if="thankyouSetting.useImageItem || thankyouSetting.useTextItem"
            class="d-flex align-center flex-column"
            style="gap: 8px"
          >
            <img
              v-if="thankyouSetting.useImageItem && thankyouSetting.imageItem"
              :src="thankyouSetting.imageItem"
              style="width: 40%; object-fit: contain"
            />
            <div
              v-if="thankyouSetting.useTextItem && thankyouSetting.textItem"
              class="mb-3 d-flex justify-center align-center"
              style="width: 60%"
              :style="{
                color: thankyouSetting.textItemColor,
                fontSize: `${thankyouSetting.textItemSize}px`,
              }"
            >
              {{ thankyouSetting.textItem }}
            </div>
          </div>
          <div
            class="ql-editor"
            v-html="formatHtmlDetail(thankyouSetting.textDescription)"
          ></div>
        </div>
        <div class="w-100 px-4 my-10">
          <v-btn
            data-testid="btn-back"
            class="w-100"
            style="text-transform: unset !important"
            :style="{
              color: thankyouSetting.colorTextAction,
              backgroundColor: thankyouSetting.bgColorTextAction,
            }"
            @click="handleSubmit"
            >{{ thankyouSetting.textAction }}</v-btn
          >
        </div>
      </div>
    </div>

    <!-- สำหรับทำ Confetti -->
    <div
      id="container_confetti"
      :style="{
        position: 'absolute',
        zIndex: 2,
        top: 0,
        left: 0,
        right: 0,
        bottom: '20%',
        pointerEvents: 'none',
      }"
    >
      <Firework v-if="isFirework" />
      <canvas
        v-if="false"
        id="myConfettiCanvas"
        style="width: 100%; height: 100%"
      ></canvas>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import Firework from "@/components/game/firework.vue";
import {
  addClassQlEditorToSDDisplay,
  customThemeSurveyJS,
  formatHtmlDetailDefault,
} from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeThankyouGame",
  inject: ["isAppLoading"],
  components: {
    Survey,
    Firework,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: null,
    survey: null,
    surveyJson: null,
    themeJson: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    thankyouSetting: {},
    isFirework: false,

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    this.isAppLoading(true);
    await this.getCampaign();
    await this.getHistory();
    await this.getSurveyAndTheme();
    this.isAppLoading(false);
    this.useFirework();

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    async getHistory() {
      try {
        const response = await MicrositeAxios.get(
          `checkPhoneNumber/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );
        const userExists = response.data.data.users;
        const transaction_id = this.$route.query.transaction_id;
        const modelTransaction = userExists?.campaignTransaction?.find(
          (x) => x.id == transaction_id
        );
        if (modelTransaction) {
          let item_json = null;
          try {
            item_json = JSON.parse(modelTransaction.item_json);
          } catch {
            //
          }
          this.thankyouSetting.textItem = item_json?.name;
          this.thankyouSetting.imageItem = item_json?.image;
        } else {
          this.$swal
            .fire({
              icon: "warning",
              text: this.$t("microsite.errGeneral"),
              showCancelButton: false,
              confirmButtonText: this.$t("microsite.textBack"),
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: "microsite-menu" });
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;

        if (this.campaign.thankyou_json) {
          this.thankyouSetting = JSON.parse(this.campaign.thankyou_json);
        } else {
          this.thankyouSetting = {
            useImageItem: true,
            useTextItem: true,
            textAction: this.$t("microsite.confirmDefault"),
          };
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.thankyou) {
        this.surveyJson = surveyJson.thankyou;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).thankyou;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    handleSubmit() {
      this.onSubmit();
    },
    async onSubmit() {
      this.$router.push({ name: "microsite-menu" });
    },
    useFirework() {
      if (!this.thankyouSetting.useFirework) return;
      // ========== ========== ========== ==========
      this.isFirework = false;
      setTimeout(() => {
        this.isFirework = true;
      }, 500);
      // ========== ========== ========== ==========
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
  },
};
</script>

<style scoped>
/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-body {
  padding-bottom: 1px !important; /* ใส่ 0px แล้วมี scrollbar โผล่เฉย */
}
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
